export default function CTASection() {
  return (
    <section className="py-20 bg-gradient-to-br from-slate-900 to-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Richiedi una Valutazione BCI
          </h2>
          <p className="text-xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed">
            Scopri il vero valore del tuo brand con la metodologia più avanzata 
            e affidabile del mercato. Una perizia certificata e legalmente difendibile.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-[#E879F9] to-[#E879F9] rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-calendar-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Tempi Certi</h3>
              <p className="text-gray-300 text-sm">Perizia completa in 5-7 giorni lavorativi</p>
            </div>

            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-[#22C55E] to-[#22C55E] rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Garanzia Totale</h3>
              <p className="text-gray-300 text-sm">Metodologia certificata e brevettata</p>
            </div>

            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-[#E879F9] to-[#E879F9] rounded-2xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-star-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Expertise Qualificata</h3>
              <p className="text-gray-300 text-sm">Team di specialisti certificati</p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <a 
              href="/contatti" 
              className="px-8 py-4 bg-gradient-to-r from-[#22C55E] to-[#22C55E] text-white font-semibold rounded-xl hover:from-[#22C55E] hover:to-[#16A34A] transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              Richiedi Consulenza
            </a>
            
            <a 
              href="/servizi" 
              className="px-8 py-4 border-2 border-[#E879F9] text-[#E879F9] font-semibold rounded-xl hover:bg-[#E879F9] hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-information-line mr-2"></i>
              Scopri i Servizi
            </a>
          </div>

          <div className="mt-16 p-8 bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl max-w-4xl mx-auto">
            <div className="flex items-center justify-center mb-4">
              <div className="w-8 h-8 bg-[#E879F9] rounded-lg flex items-center justify-center mr-3">
                <i className="ri-star-line text-white text-lg"></i>
              </div>
              <h3 className="text-xl font-semibold text-white">Perché Scegliere il BCI</h3>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left">
              <div className="space-y-3">
                <div className="flex items-center text-gray-300">
                  <i className="ri-check-line text-[#22C55E] mr-2"></i>
                  <span className="text-sm">Unica metodologia brevettata in Italia</span>
                </div>
                <div className="flex items-center text-gray-300">
                  <i className="ri-check-line text-[#22C55E] mr-2"></i>
                  <span className="text-sm">Riconosciuta da Banca d'Italia e Agenzia Entrate</span>
                </div>
                <div className="flex items-center text-gray-300">
                  <i className="ri-check-line text-[#22C55E] mr-2"></i>
                  <span className="text-sm">Validazione accademica internazionale</span>
                </div>
              </div>
              
              <div className="space-y-3">
                <div className="flex items-center text-gray-300">
                  <i className="ri-check-line text-[#22C55E] mr-2"></i>
                  <span className="text-sm">Accuratezza superiore al 92%</span>
                </div>
                <div className="flex items-center text-gray-300">
                  <i className="ri-check-line text-[#22C55E] mr-2"></i>
                  <span className="text-sm">Resistente ai controlli di revisione</span>
                </div>
                <div className="flex items-center text-gray-300">
                  <i className="ri-check-line text-[#22C55E] mr-2"></i>
                  <span className="text-sm">Supporto legale e metodologico incluso</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}